import { render, staticRenderFns } from "./UploadMaterial.vue?vue&type=template&id=61373530&scoped=true"
import script from "./UploadMaterial.vue?vue&type=script&lang=js"
export * from "./UploadMaterial.vue?vue&type=script&lang=js"
import style0 from "./UploadMaterial.vue?vue&type=style&index=0&id=61373530&prod&lang=scss"
import style1 from "./UploadMaterial.vue?vue&type=style&index=1&id=61373530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61373530",
  null
  
)

export default component.exports